(() => {
  const payments = document.querySelector('.alv-kaki-it-payments');
  const section = payments?.closest('section.color-background-1');
  const info = payments?.closest('product-info');
  if (!payments || !section || !info) return;

  let lastOffset = -1;
  let scheduled = false;
  const paint = () => {
    scheduled = false;
    const offset = Math.max(0, Math.round(payments.getBoundingClientRect().top - section.getBoundingClientRect().top));
    if (offset === lastOffset) return;
    lastOffset = offset;
    section.style.backgroundImage = `linear-gradient(180deg, transparent 0 ${offset}px, #faf7f1 ${offset}px)`;
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(paint);
  };
  schedule();
  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule);
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(info);
  setTimeout(schedule, 500);
  setTimeout(schedule, 1800);
})();
